import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/sections/Header";
import TheDeck from "@/sections/TheDeck";
import FooterSection from "@/sections/Footer";
import { DECK_LIBRARY } from "@/lib/decks";

export default function DecksPage() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    const previousTitle = document.title;
    document.title = "Deck Library — DCYB";
    return () => { document.title = previousTitle; };
  }, []);

  useEffect(() => {
    const key = new URLSearchParams(location.search).get("open");
    if (!key || !DECK_LIBRARY.some((deck) => deck.key === key)) return undefined;
    const timer = window.setTimeout(() => window.dispatchEvent(new CustomEvent("dcyb:open-deck", { detail: { key } })), 350);
    return () => window.clearTimeout(timer);
  }, [location.search]);

  return (
    <main data-testid="decks-page" className="relative">
      <Header />
      <div className="border-b hairline bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
          <Link to="/" data-testid="decks-back-home-link" className="inline-flex items-center gap-2 font-mono-label text-[11px] text-[#5F6168] hover:text-[#0F1117] transition-colors">
            <ArrowLeft size={14} aria-hidden="true" />Back to DCYB
          </Link>
        </div>
      </div>
      <TheDeck />
      <FooterSection />
    </main>
  );
}
